// extracted by mini-css-extract-plugin
module.exports = {"searchButton":"UserSearchFormItem_searchButton__3FArG","searchButtonWrapper":"UserSearchFormItem_searchButtonWrapper__2shP1","tag":"UserSearchFormItem_tag__1p3pm"};